<template>
  <div :class="(!uid) ? 'container-fluid mt-2' : 'm-1'">
    <div class="row">
      <div class="card">
        <div class="card-header">
          {{ t.custom_reseller_panel.account_in_out }}
        </div>
        <DateFilter :startDate="startDate" :endDate="endDate" type="account"></DateFilter>
        <div class="card-block p-0">
          <div class="table-responsive">
            <table class="table mb-0">
              <thead>
              <tr>
                <th colspan="4">
                  <span class="tag tp tag-primary">{{ t.time_range}}</span> {{ startDate }} - {{ endDate }}<br> <!--tr-->
                  <span class="tag tp tag-info">{{ t.custom_reseller_panel.balance_in }}</span> {{ total.in | toMoney(session.currency) }} <br> <!-- tr -->
                  <span class="tag tp tag-danger">{{ t.custom_reseller_panel.balance_out }}</span> {{ total.out | toMoney(session.currency) }}<br> <!-- tr -->
                  <span class="tag tp tag-success">{{ t.giro }}</span> {{ total.result | toMoney(session.currency) }} <!-- tr -->
                </th>
              </tr>
              <tr v-if="$root.windowWidth >= 600">
                <th>{{ t.type }}</th> <!-- tr -->
                <th>{{ t.amount }}</th>
                <th>{{ t.betting.title.date }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-if="loading">
                <td colspan="4" align="center">
                  <Loading></Loading>
                </td>
              </tr>
              <template v-if="!loading">
                <tr v-if="transactions.length < 1">
                  <td colspan="4" align="center">Kayıt yok</td> <!-- tr -->
                </tr>
                <template v-else-if="$root.windowWidth < 600">
                  <tr v-for="(transaction, idx) in transactions" :key="idx">
                    <td colspan="5">
                      <div class="card-views">
                        <div class="card-view">
                          <span class="title font-weight-bold" style="">{{ t.type }}</span> <!-- tr -->
                          <span class="value">{{ transaction.id }}</span>
                        </div>
                        <div class="card-view">
                          <span class="title font-weight-bold">{{ t.amount }}</span>
                          <span class="value amnount" :class="transaction.type === 11 ? 'text-success' : 'text-danger'">
                          {{ transaction.amount  | toMoney(session.currency)  }}
                          </span>
                        </div>
                        <div class="card-view">
                          <span class="title font-weight-bold" style="">{{ t.betting.title.date }}</span>
                          <span class="value">{{ dateTimeFormat(transaction.added_date) }}</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr v-for="(transaction, idx) in transactions" :key="idx">
                    <td>
                      <span class="tag" :class="transaction.type.operator === '+' ? 'tag-info' : 'tag-danger'" v-text="transaction.type.operator === '+' ? t.custom_reseller_panel.balance_in : t.custom_reseller_panel.balance_out">Kar</span> <!-- tr -->
                    </td>
                    <td>
                      <span class="amount">
                        <code :class="transaction.type === 11 ? 'text-success' : 'text-danger'">{{ transaction.amount | toMoney(session.currency) }}</code>
                      </span>
                    </td>
                    <td>{{ dateTimeFormat(transaction.added_date) }}</td>
                  </tr>
                </template>
              </template>
              </tbody>
            </table>
            <div class="fixed-table-footer">
              <paginate v-if="pagination" class="mx-3"
                        :page-count="pagination.pageCount"
                        :page-range="pagination.pageRange"
                        :force-page="pagination.current"
                        :initialPage="pagination.current"
                        :margin-pages="$root.windowWidth < 600 ? 0 : 2"
                        :click-handler="onChangePage"
                        :prev-text="t.previous"
                        :next-text="t.next"
                        :container-class="'my-1 pagination float-right mr-0 ml-1'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :prev-class="'page-item'"
                        :prev-link-class="'page-link'"
                        :next-class="'page-item'"
                        :next-link-class="'page-link'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateFilter from "../DateFilter";
import Paginate from 'vuejs-paginate'
import Loading from "../Loading";
export default {
  name: "AdminDeposit",
  components: {Loading, DateFilter, Paginate},
  props: ['uid'],
  data() {
    return {
      startDate: moment(new Date(new Date().setDate(new Date().getDate() - 1))).format("DD MMMM YYYY ddd"),
      endDate: moment(new Date()).format("DD MMMM YYYY ddd"),
      transactions: [],
      session: session,
      pagination: null,
      t: this.$root.t,
      total: {in: 0.00, out: 0.00, result: 0.00},
      loading: false
    }
  },
  mounted() {
    this.$router.push({ query: {page: 1} });
    this.fetchTransactions(null, null, false);
  },
  methods: {
    fetchTransactions(from, to, pageCheck) {
      console.log(to)
          this.loading = true;
          this.$http.get(api + 'api/v1/reseller_deposit/'+this.uid, {
            params: {
              uid: this.uid,
              type: [30, 31, 5 , 9 , 10 , 16, 32, 11],
              page: this.$route.query.page,
              per_page: 100,
              direction: 'desc',
              start: from ? from : moment(moment(new Date()).format()).add(-1, 'd').format('YYYY-MM-DD'),
              end: to ? to : moment().add(+1, 'd').format("YYYY-MM-DD")
            }
          })
          .then(response => {
            this.transactions = response.body.result;

            if(this.transactions){

                this.transactions.forEach(element => {
                    if(element.type === 11){
                        this.total.in += parseFloat(element.amount)
                    }else {
                        this.total.out += parseFloat(element.amount)
                    }
                });

                this.total.result = this.total.in - this.total.out;
            }

            this.loading = false;
          }, response => {
            this.transactions = [];
            this.loading = false;
          })
    },
    onChangePage (page) {
      this.pagination.current = page;
      this.$router.push({ query: {page: page} });
      window.scroll(0, 0);
      this.fetchTransactions(this.startDate, this.endDate, true)
    },
  }
}
</script>

<style scoped>
.tag.tp {
  width:100px;
  text-align:left
}

</style>



// WEBPACK FOOTER //
// src/components/views/AdminDeposit.vue